import * as XLSX from "xlsx";

// Single shared Excel export. Every export site funnels through this so the
// workbook/download logic lives in exactly one place.
//
//   columns  — [{ key, label, get(row) }] (already filtered to the user's choice)
//   rows     — array of row objects
//   filename — base name; ".xlsx" is appended if missing
//   sheet    — worksheet name (default "Export")
export function downloadExport({ columns, rows, filename, sheet = "Export" }) {
  const header = columns.map((c) => c.label);
  const body = rows.map((r) => columns.map((c) => c.get(r)));

  const ws = XLSX.utils.aoa_to_sheet([header, ...body]);
  ws["!cols"] = columns.map((c) => ({ wch: Math.max(12, String(c.label).length + 2) }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheet);
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}

// yyyy-mm-dd for filenames.
export function exportStamp() {
  return new Date().toISOString().slice(0, 10);
}
